import { ChangeDetectionStrategy, Component, input, model } from "@angular/core";

@Component({
  template: "<div></div>",
  selector: "mn-switcher",
  styleUrls: ["./switcher.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { "(click)": "onClick()", "[class.checked]": "value()", "[class.disabled]": "disabled()" },
})
export class SwitcherComponent {
  public value = model<boolean>(false);

  public disabled = input<boolean>(false);

  public onClick(): void {
    if (this.disabled()) {
      return;
    }

    this.value.update(value => !value);
  }
}
